import styled from "styled-components";

export const UserSideMenu = styled.section`
  display: flex;
  width: 100vw;
  min-height: calc(100vh - 56px);
  background: ${(props) => props.theme.colors.white100};
  flex-direction: column;
`;
